import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import ForgotPasswordPage from './auth/ForgotPasswordPage';
import ResetPasswordPage from './auth/ResetPasswordPage';
import StudentDashboard from './pages/StudentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import { AuthContext, AuthProvider } from './context/AuthContext';
import StudentRoute from './routes/StudentRoute';
import AdminRoute from './routes/AdminRoute';
import StudentBookingPage from './pages/StudentBookingPage';
import HostelSeatMap from './pages/HostelSeatMap';
import LibrarySeatMap from './pages/LibrarySeatMap';
import HostelBookingForm from './pages/HostelBookingForm';
import LibraryBookingForm from './pages/LibraryBookingForm';
import HostelBookingHistory from './pages/HostelBookingHistory';
import LibraryBookingHistory from './pages/LibraryBookingHistory';
import RoomBedManager from './pages/RoomBedManager';
import LibrarySeatManager from './pages/LibrarySeatManager';
import { Toaster } from 'react-hot-toast';
import AdminStudentList from './pages/AdminStudentList';

function AppRoutes() {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  const publicPaths = ['/', '/login', '/register', '/forgot-password', '/reset-password'];
  const currentPath = location.pathname;
  const isPublic = publicPaths.some(path => currentPath.startsWith(path));

  if (!isAuthenticated() && !isPublic) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />
      <Route path="/student/hostel" element={<StudentRoute><HostelSeatMap /></StudentRoute>} />
      <Route path="/student/library" element={<StudentRoute><LibrarySeatMap /></StudentRoute>} />
      <Route path="/student/book/hostel/:bedId" element={<StudentRoute><HostelBookingForm /></StudentRoute>} />
      <Route path="/student/book/library/:seatId" element={<StudentRoute><LibraryBookingForm /></StudentRoute>} />
      <Route path="/student/book" element={<StudentRoute><StudentBookingPage /></StudentRoute>} />
      <Route path="/student/dashboard" element={<StudentRoute><StudentDashboard /></StudentRoute>} />
      <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/hostel-history" element={<HostelBookingHistory />} />
      <Route path="/library-history" element={<LibraryBookingHistory />} />
      <Route path="/admin/manage-rooms" element={<RoomBedManager />} />
      <Route path="/admin/manage-seats" element={<LibrarySeatManager />} />
      <Route path="/admin/students" element={<AdminStudentList />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
